import {
  MdAssignment,
  MdCookie,
  MdDescription,
  MdHandshake,
  MdInfoOutline,
  MdLink,
  MdMarkEmailRead,
  MdOutlineFlashOn,
  MdOutlineReportProblem,
  MdPublic,
  MdSchedule,
  MdWarningAmber,
} from "react-icons/md";

const ICONS = {
  "hors-ue": MdPublic,
  "ropa-pia-requis": MdWarningAmber,
  /** Référentiels — lignes pays / CCT / DPA (couleurs comme RefSousTraitants) */
  "st-hors-eee": MdPublic,
  "st-cct-activer": MdLink,
  "st-dpa-signer": MdHandshake,
  "preuve-non-conforme": MdDescription,
  "retrait-recue": MdMarkEmailRead,
  "retrait-encours": MdMarkEmailRead,
  "gravite-inc-mineure": MdOutlineFlashOn,
  "gravite-inc-moderee": MdOutlineFlashOn,
  "gravite-inc-majeure": MdOutlineFlashOn,
  "gravite-inc-critique": MdOutlineFlashOn,
  "droit-hors-delai": MdWarningAmber,
  /** Rétrocompat (anciennes entrées) */
  pia: MdAssignment,
  consentement: MdCookie,
  preuve: MdDescription,
  "cct-eee": MdLink,
  incident: MdOutlineReportProblem,
  droits: MdSchedule,
  dpa: MdHandshake,
  default: MdInfoOutline,
};

/**
 * Une ou plusieurs pastilles ; priorité à `problemBadges[]`, sinon `problemBadge` unique.
 */
export function normalizeProblemBadges(action) {
  if (Array.isArray(action?.problemBadges) && action.problemBadges.length > 0) {
    return action.problemBadges.filter((b) => b?.variant && b?.text != null && String(b.text).length > 0);
  }
  if (action?.problemBadge?.variant && action?.problemBadge?.text != null && String(action.problemBadge.text).length > 0) {
    return [action.problemBadge];
  }
  return [];
}

/**
 * Pastilles alignées sur les badges des modules (ROPA, référentiels, statuts métier…).
 */
export function PriorityProblemBadge({ variant, text, className = "" }) {
  const Icon = ICONS[variant] || ICONS.default;
  const v = variant || "default";
  return (
    <span className={`ta-notif-problem ta-notif-problem--${v} ${className}`.trim()} title={text}>
      <Icon size={12} aria-hidden />
      <span>{text}</span>
    </span>
  );
}
